import { siteApiSlice } from "../../../../app/siteApiSlice";
import { DataTablesViewModel } from "../../../../interfaces/dataTables";
import { PlagiarismReportViewModel, PlagiarismAnalysisModel } from "./PlagiarismReportViewModels";

export const plagiarismReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		plagiarismReport: build.query<PlagiarismReportViewModel, { courseId?: number }>({
			query: (arg) => {
				const { courseId } = arg;
				return {
					url: `/report/PlagiarismReport`,
					params: { courseId },
				};
			},
		}),
		plagiarismReportData: build.query<
			DataTablesViewModel<PlagiarismAnalysisModel>,
			{ courseId: number; promptId: number }
		>({
			query: (arg) => {
				const { promptId, courseId } = arg;
				return {
					url: `/report/PlagiarismReportAjax`,
					params: { courseId, promptId },
				};
			},
		}),
	}),
});

export const { usePlagiarismReportQuery, useLazyPlagiarismReportDataQuery } =
	plagiarismReportApiSlice;
